var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-icon',{style:(_vm.iconStyle),attrs:{"type":_vm.iconType},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }